import { DEFAULT_DATA } from '@/shared/constants/config';

export default function CategoryReviewStep({ theme: t }) {
  const expenseGroups = DEFAULT_DATA.cats.expense;

  return (
    <div style={{ textAlign: 'center' }}>
      <h2 style={{ fontSize: 20, fontWeight: 800, color: t.text, margin: '0 0 8px' }}>
        Your Starting Categories
      </h2>
      <p style={{ fontSize: 13, color: t.textMuted, marginBottom: 20, lineHeight: 1.5 }}>
        We've set up common categories for Australian households. You can customize these anytime.
      </p>
      <div style={{
        maxHeight: 300, overflowY: 'auto', textAlign: 'left',
        display: 'flex', flexDirection: 'column', gap: 8,
      }}>
        {Object.entries(expenseGroups).map(([group, items]) => (
          <div key={group} style={{
            background: t.sectionBg, borderRadius: 10, padding: '10px 14px',
            border: '1px solid ' + t.cardBorder,
          }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: t.text, marginBottom: 4 }}>{group}</div>
            <div style={{ fontSize: 12, color: t.textMuted, lineHeight: 1.6 }}>
              {items.join(' \u00B7 ')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
